import React from "react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import DefaultAvatar from "../../components/DefaultAvatar";
import HoverActionsMenu from "../../components/HoverActionsMenu";

interface QuickNotesRowProps {
  log: any;
  time: string;
  summary: string;
  actorName: string;
  actorAvatar: string;
  deadlineDetail?: string;
  onOpen: (id: string | number) => void;
  onDelete?: (id: string | number) => void;
}

const QuickNotesRow: React.FC<QuickNotesRowProps> = ({
  log,
  time,
  summary,
  actorName,
  actorAvatar,
  deadlineDetail,
  onOpen,
  onDelete,
}) => {
  return (
    <div className="relative group flex items-start w-full">
      <div className="flex items-center w-full gap-2 cursor-pointer hover:bg-gray-50 rounded px-1 py-0.5 -mx-1">
        {/* Time label - 150px width, Inter Regular 10px */}
        <div className="w-[150px] text-[10px] text-gray-500 leading-4 shrink-0">{time}</div>

        {/* Note section - 420px fixed width */}
        <div className="w-[420px] flex items-center gap-2 shrink-0">
          {/* Pencil icon - 16x16 */}
          <span className="inline-flex items-center justify-center w-4 h-4 text-gray-500 shrink-0">
            <PencilSquareIcon className="w-4 h-4" />
          </span>
          {/* Title - Inter Medium 12px, gray-900 */}
          <span className="text-[12px] font-medium text-gray-900 leading-4 truncate">
            {summary}
          </span>
        </div>

        {/* Content section: Avatar + Name + Detail */}
        <div className="flex items-center gap-2 min-w-0 flex-1">
          {/* Avatar - 20x20 */}
          {actorAvatar ? (
            <img
              src={actorAvatar}
              alt=""
              className="w-5 h-5 rounded-full shrink-0"
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).style.display = "none";
              }}
            />
          ) : (
            <DefaultAvatar name={actorName} size="sm" className="w-5 h-5 rounded-full shrink-0" />
          )}
          {/* Name - Inter Medium 12px, gray-900 */}
          {actorName && (
            <span className="text-[12px] font-medium text-gray-900 leading-4 shrink-0">
              {actorName}
            </span>
          )}
          {/* Detail - Inter Regular 12px, yellow for deadline */}
          {deadlineDetail && (
            <span className="text-[12px] text-[#eab308] leading-4 shrink-0">{deadlineDetail}</span>
          )}
        </div>
      </div>

      {/* Hover Actions Menu */}
      <HoverActionsMenu
        onOpen={() => onOpen(log.get("id"))}
        onDelete={onDelete ? () => onDelete(log.get("id")) : undefined}
      />
    </div>
  );
};

export default QuickNotesRow;
